// Module
var code = "<div class=\"q-number-input\" ng-class=\"{disabled: disabled}\"> <div class=\"controls center\"> <div class=\"control button center\" ng-click=\"decrement()\">–</div> <input type=\"number\" ng-min=\"min\" ng-max=\"max\" ng-model=\"model\"> <div class=\"control button center\" ng-click=\"increment()\">+</div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'Common/AtomicUI/NumberInput/NumberInput.ng.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;